module.exports = {
      id: "percent-usage",
      viewBox: "0 0 26 20",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#percent",
      toString: function () {
        return this.url;
      }
    }